import Avatar from "src/components/Admin/Avatar";
import screencloudLogo from "src/images/logo-placeholder.png";
import { getFullName } from "src/helpers/userHelper";
import { User } from "src/types.g";
import { Styled } from "./styles";

interface UserProps {
  user: User | null | undefined;
}
export const UserWithAvatar = ({ user }: UserProps): JSX.Element => {
  const picture = user ? user?.metadata?.picture : screencloudLogo;
  const fullName = user ? getFullName(user as User) : "System";
  return (
    <Styled>
      <Avatar url={picture} name={fullName} className="avatar" size={24} />
      <div className="info">
        <h3 className="name">{fullName}</h3>
        {user?.email && <span className="email">{user?.email}</span>}
      </div>
    </Styled>
  );
};
